import React from 'react';
import TableSettingsView from '../../../../../shared/TableSettings/TableSettingsView';
import { LotTableSettingsColumn } from '../../../../../../types/table_settings/lot/LotTableSettings';
import { EntityType } from '../../../../../../types/comment';
import { CustomFieldEntityType } from '../../../../../../types/custom_field';
import { translate } from '../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';

export default function LotTableSettingsPane() {
  return (
    <div className='content-x'>
      <TableSettingsView<LotTableSettingsColumn>
        type={EntityType.lot}
        customFieldEntityType={CustomFieldEntityType.lot}
        availableColumns={Object.values(LotTableSettingsColumn)}
        columnTextBuilder={item => translate({ key: item })}
        label={translate({ key: TranslationKey.addLotColumn })}
        placeholder={translate({ key: TranslationKey.addLotColumn })}
      />
    </div>
  );
}
